import { render, staticRenderFns } from "./SettingSubscriptions.vue?vue&type=template&id=1a1a12e5&"
import script from "./SettingSubscriptions.vue?vue&type=script&lang=js&"
export * from "./SettingSubscriptions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports